import React, { useState, useEffect } from "react";

import { Container, Row, Col } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import EditarClienteForm from "./editar-cliente-form";
import swal from "sweetalert";
import EditarPerfilIndividualForm from "../editar-perfil-individual/editar-perfil-individual-form";
import BrushOutlinedIcon from "@material-ui/icons/BrushOutlined";
import PersonIcon from "@material-ui/icons/Person";

const EditarClienteExistente = ({ type, urlApiGet }) => {
  //Definimos un estado para guardar la informacion del autocomplete
  const [autoCompleteValue, setAutoCompleteValue] = useState(null);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  useEffect(() => {
    clearSelection();
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, urlApiGet]);

  //fetch Users List
  const fetchUsers = async () => {
    const fd = new FormData();
     
    fd.append("show", "all");
    fd.append("tipoUsuario", type);
    const res = await fetch(urlApiGet, {
      method: "POST", credentials: 'include',
      body: fd,
    });
    const resJSON = await res.json();

    if (resJSON.status === 0) {
      await swal({
        title: "Error",
        text: resJSON.info,
        icon: "error",
      });
    } else {
      const normalizedData = normalizePersonalUsers(resJSON.data || []);
      setAutoCompleteOptions(normalizedData);
    }
  };

  //Funcion para actualizar el valor seleccionado por el autocomplete
  const autoCompleteUpdate = async (e, newValue) => {
    // console.log(newValue);
    if (newValue) setAutoCompleteValue(newValue);
  };

  const clearSelection = async () => {
    setAutoCompleteOptions([]);
    await fetchUsers();
    setAutoCompleteValue(null);
  };
  const normalizeInstitutesPayload = (entries = []) =>
    entries
      .map((entry) => {
        const name =
          entry?.nombre ||
          entry?.instituto ||
          entry?.institute ||
          entry?.institucion ||
          entry?.name;
        if (!name) {
          return null;
        }
        const assignedUser =
          entry?.usuarioInstituto ||
          entry?.usuario ||
          entry?.usuario_padre ||
          entry?.username;
        return {
          nombre: name,
          instituto: name,
          institucion: name,
          institute: name,
          usuarioInstituto: assignedUser || null,
          usuario: assignedUser || null,
        };
      })
      .filter(Boolean);

  const enhanceUserWithInstitutes = (user, institutes) => {
    const safeInstitutes = institutes.length ? institutes : [];
    const firstInstitute = safeInstitutes[0]?.nombre || "";

    return {
      ...user,
      institutos: safeInstitutes,
      instituciones: safeInstitutes,
      institucionesAsociadas: safeInstitutes,
      institucionesRelacionadas: safeInstitutes,
      institutes: safeInstitutes,
      institute: user?.institute || firstInstitute,
      instituto: user?.instituto || firstInstitute,
    };
  };

  const normalizePersonalUsers = (users = []) => {
    if (type !== "Personal") {
      return users || [];
    }

    if (!Array.isArray(users) || !users.length) {
      return [];
    }

    const hasInstitutesArray = users.some((user) => {
      const institutesCandidate =
        user?.institutos ||
        user?.instituciones ||
        user?.institucionesAsociadas ||
        user?.institucionesRelacionadas ||
        user?.institutes;
      return Array.isArray(institutesCandidate) && institutesCandidate.length;
    });

    if (hasInstitutesArray) {
      return users.map((user) => {
        const candidates =
          user?.institutos ||
          user?.instituciones ||
          user?.institucionesAsociadas ||
          user?.institucionesRelacionadas ||
          user?.institutes ||
          [];
        const normalizedInstitutes = normalizeInstitutesPayload(candidates);
        return enhanceUserWithInstitutes(user, normalizedInstitutes);
      });
    }

    const grouped = users.reduce((acc, current) => {
      const key = current?.username || current?.emailIndividual || current?.email;
      if (!key) {
        return acc;
      }

      if (!acc[key]) {
        const existingInstitutions =
          current?.institutos ||
          current?.instituciones ||
          current?.institucionesAsociadas ||
          current?.institucionesRelacionadas ||
          current?.institutes ||
          [];

        acc[key] = {
          ...current,
          institutos: normalizeInstitutesPayload(existingInstitutions),
        };
      }

      const rowInstitutes = normalizeInstitutesPayload([current]);
      rowInstitutes.forEach((inst) => {
        const alreadyExists = acc[key].institutos.some(
          (stored) =>
            stored.nombre === inst.nombre &&
            stored.usuarioInstituto === inst.usuarioInstituto
        );

        if (!alreadyExists) {
          acc[key].institutos.push(inst);
        }
      });

      return acc;
    }, {});

    return Object.values(grouped).map((user) =>
      enhanceUserWithInstitutes(user, user.institutos || [])
    );
  };

  /*
    Esta pagina cambia dependiendo si un usuario ha seleccionado un elemento del autocomplete
    si el valor del autoCompleteValue es null se retorna el autocomplete
    si ese valor no es null se retorna el formulario para editar un clietne
  */
  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <BrushOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">
          Editar un cliente {type} existente
        </div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <PersonIcon style={{ fontSize: "22px" }} />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                Buscar y editar un cliente {type} existente
              </div>
            </div>
            {!autoCompleteValue ? (
              <>
                <label className="admin-label-text mt-3 d-block">Buscar:</label>
                <Autocomplete
                  options={autoCompleteOptions}
                  getOptionLabel={(option) => option.username}
                  value={autoCompleteValue}
                  onChange={autoCompleteUpdate}
                  noOptionsText="Sin resultados"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{
                        width: "100%",
                        fontFamily: "'Noto Sans JP', sans-serif",
                      }}
                    />
                  )}
                />
              </>
            ) : (
              type === "Personal" ? (
                <EditarPerfilIndividualForm
                  clearSelection={clearSelection}
                  selectedOption={autoCompleteValue}
                />
              ) : (
              <EditarClienteForm
                clearSelection={clearSelection}
                selectedOption={autoCompleteValue}
                type={type}
              />
              )
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditarClienteExistente;
